/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    CAMPAIGNS: 'Kampagnen',
    CERTIFICATES: 'Zertifikate',
    CHALLENGES: 'Challenges',
    CHAT: 'Chat',
    CLOSE: 'Schließen',
    CLUB: 'Club',
    COMMISSIONED_PRODUCTS: 'Produkte und entsprechende Provision',
    COMMUNICATIONS: 'Kommunikationen',
    CONFIRM: 'Bestätigen',
    COUNTERPART: 'Gegenleistungen',
    DASHBOARD: 'Dashboard',
    DESIGN_REQUESTS: 'Design',
    DETAILS: 'Details',
    EXTERNAL_APPLICATIONS: 'Externe Anwendungen',
    FOLLOWER_MESSAGES: 'Nachrichten von Anhängern',
    GENERICS: 'Generika',
    LINKS: 'Links',
    LIVE: 'Liveübertragungen',
    LOGOUT: 'Abmelden',
    MEMBERS: 'Mitglieder',
    MENTIONS: 'Erwähnt',
    OFFERS: 'Angebote',
    ON_DEMAND_CAMPAIGNS: 'On-Demand-Kampagnen',
    OPPORTUNITIES: 'Challenge',
    ORDERS: 'Bezahlte Bestellungen',
    PARTNERS: 'Partner',
    PERSONAL_AREA: 'Persönlicher Bereich',
    PRODUCTS_OFFERED: 'An dich verschenkte Produkte',
    PROFILE: 'Profil',
    PROZIS_COMMUNITY: 'Prozis-Community',
    QUESTIONS: 'Fragen',
    REMUNERATIONS: 'Vergütungen',
    SELECT_LANGUAGE: 'Sprache auswählen',
    SELECT_PARTNER: 'Einen anderen Partner auswählen',
    SERVICES: 'Dienstleistungen',
    SOCIAL_NETWORK: 'Prozis Soziales netzwerk',
    STATISTICS: 'Statistiken',
    VIDEO_TUTORIALS: 'Video-Tutorials'
  },
  ERROR: {
    ERROR: 'Fehler',
    FETCH_DATA: 'Daten abrufen'
  },
  HEADER: {},
  LABEL: {
    CAMPAIGNS: 'Kampagnen',
    CHALLENGES: 'Challenges',
    CHAT: 'Chat',
    COMMUNICATIONS: 'Kommunikationen',
    COUNTERPARTS: 'Gegenleistungen',
    DASHBOARD: 'Kontrollpanel',
    DESIGN_REQUESTS: 'Design',
    DETAILS: 'Details',
    EXTERNAL_APPLICATIONS: 'Externe Anwendungen',
    FILTER: 'Filter',
    FILTERED: 'Gefiltert',
    FOLLOWER_MESSAGES: 'Nachrichten von Anhängern',
    GENERICS: 'Generika',
    HOME: 'Startseite',
    LINKS: 'Links',
    LOGOUT: 'Abmelden',
    MEMBERS: 'Mitglieder',
    MENTIONS: 'Instagram-Erwähnungen',
    NOT_FOUND: '404. Hast du dich verlaufen?',
    OFFERS: 'Angebote',
    ORDERS: 'Bestellungen',
    PARTNERSHIP_NOT_FOUND: 'Keine Partnerschaft gefunden.',
    PENDING_COUNTERPART: 'Ausstehende Gegenleistungen des vorherigen Zeitraums',
    PENDING_COUNTERPART_CURRENT:
      'Ausstehende Gegenleistungen des aktuellen Monats',
    PENDING_REMUNERATION: 'Ausstehende Vergütungen des vorherigen Zeitraums',
    PENDING_REMUNERATION_CURRENT:
      'Ausstehende Vergütungen des aktuellen Monats',
    PERSONAL_AREA: 'Persönlicher Bereich',
    PRODUCTS: 'Produkte',
    REMUNERATIONS: 'Vergütungen',
    SEARCH_PARTNERSHIP: 'Nach einer Partnerschaft suchen',
    SELECT_LANGUAGE: 'Sprache auswählen',
    SELECT_PARTNERSHIP: 'Partnerschaft auswählen',
    UNAUTHROZIED: '403. Zugriff verweigert!!!'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
